module.exports = function (propertyData, cropAlias, maxWidth, format, bgcolor, quality = 80) {

    if (!propertyData || propertyData.length === 0 || propertyData[0] !== '{') return "";

    var imageData = JSON.parse(propertyData);
    
    if (!imageData.crops) return "";

    const crop = imageData.crops.find(x => x.alias === cropAlias);
    
    let cropUrl = imageData.src +
        (imageData.src.indexOf("?") > 0 ? "&" : "?")
        + "mode=crop&cropmode=percentage";
    if (crop) {
        if (crop.coordinates) {
            cropUrl += "&crop=" +
                parseInt(crop.coordinates.x1) +
                "," +
                parseInt(crop.coordinates.y1) +
                "," +
                parseInt(crop.coordinates.x2) +
                "," +
                parseInt(crop.coordinates.y2);
        }

        const widthRatio = crop.height / crop.width;

        if (crop.width) {
            cropUrl += "&width=" + (maxWidth ? parseInt(maxWidth) : parseInt(crop.width));
        }

        if (crop.height) {
            cropUrl += "&height=" + (maxWidth ? (parseInt(maxWidth * widthRatio)) : parseInt(crop.height));
        }
    } else {
        if (maxWidth) {
            cropUrl += "&width=" + parseInt(maxWidth);
        }
        
    }

    if (format) {
        cropUrl += "&format=" + format;
        //todo: Add PostProcessing to remove meta-data
    }

    if (bgcolor) {
        cropUrl += "&bgcolor=" + bgcolor;
    }

    if (quality) {
        cropUrl += "&quality=" + quality;
    }
    
    const result = { cropUrl: cropUrl, width: crop && crop.width, height: crop && crop.height };

    return result;
};

